import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import apiService from '../../services/api'

export default function Express() {
  const [dezenas, setDezenas] = useState(6)
  const [apostas, setApostas] = useState(3)
  const [priceFormatted, setPriceFormatted] = useState('R$ 9,90')
  const [loading, setLoading] = useState(false)
  const [loadingTipIndex, setLoadingTipIndex] = useState(0)
  const loadingTips = ['Gerando a melhor combinação...', 'Aguarde...', 'Já fez os planos?']
  const buttonMaxText = [...loadingTips, 'GERAR MEUS NÚMEROS AGORA'].reduce((a,b)=> (a.length>=b.length?a:b))
  const [preview, setPreview] = useState<string[][]>([])
  const [fullGames, setFullGames] = useState<string[][]>([])
  const [token, setToken] = useState<string | null>(null)
  const [txid, setTxid] = useState<string | null>(null)
  const [pixStatus, setPixStatus] = useState<'pending'|'paid'|'expired'|'idle'>('idle')
  const [qrCode, setQrCode] = useState<string | null>(null)
  const [pixCode, setPixCode] = useState<string | null>(null)
  const [checking, setChecking] = useState(false)
  const [intervalId, setIntervalId] = useState<number | null>(null)
  const [secondsLeft, setSecondsLeft] = useState<number | null>(null)
  const [countdownId, setCountdownId] = useState<number | null>(null)
  const [lastCheckedAt, setLastCheckedAt] = useState<string | null>(null)
  const [copied, setCopied] = useState(false)
  const [showWhatsModal, setShowWhatsModal] = useState(false)
  const [whatsPhone, setWhatsPhone] = useState('')
  const [sendingWhats, setSendingWhats] = useState(false)
  const [whatsFeedback, setWhatsFeedback] = useState<string | null>(null)

  useEffect(() => {
    updatePrice()
    return () => { if (intervalId) window.clearInterval(intervalId) }
  }, [dezenas, apostas])

  useEffect(() => {
    if (loading) {
      setLoadingTipIndex(0)
      const id = window.setInterval(() => {
        setLoadingTipIndex((prev) => (prev + 1) % loadingTips.length)
      }, 1200)
      return () => window.clearInterval(id)
    }
  }, [loading])

  function clampDezenas(v: number) { return Math.min(15, Math.max(6, v)) }
  function clampApostas(v: number) { return Math.min(20, Math.max(3, v)) }

  function updatePrice() {
    const base = 990
    const extraDez = dezenas > 6 ? (dezenas - 6) * 250 : 0
    const extraApo = apostas > 3 ? (apostas - 3) * 150 : 0
    const reais = (base + extraDez + extraApo) / 100
    setPriceFormatted('R$ ' + reais.toFixed(2).replace('.', ','))
  }

  function formatSeconds(s: number) {
    const m = Math.floor(s / 60)
    const sec = s % 60
    return `${String(m).padStart(2,'0')}:${String(sec).padStart(2,'0')}`
  }

  function computeSeconds(expiresAt?: string): number {
    try {
      if (expiresAt && typeof expiresAt === 'string' && expiresAt.trim()) {
        const d = new Date(expiresAt.replace(' ', 'T'))
        const diff = Math.floor((d.getTime() - Date.now()) / 1000)
        if (isFinite(diff) && diff > 0 && diff < 3600) return diff
      }
    } catch {}
    return 240
  }

  function startCountdown(s: number) {
    if (countdownId) window.clearInterval(countdownId)
    setSecondsLeft(s)
    const id = window.setInterval(() => {
      setSecondsLeft(prev => {
        if (prev === null) return null
        if (prev <= 1) {
          window.clearInterval(id)
          setCountdownId(null)
          setPixStatus('expired')
          if (intervalId) { window.clearInterval(intervalId); setIntervalId(null) }
          return 0
        }
        return prev - 1
      })
    }, 1000)
    setCountdownId(id)
  }

  async function generate() {
    setLoading(true)
    try {
      const res = await apiService.expressGenerate({ dezenas, apostas })
      console.log('[Express] generate -> ok', res)
      setToken(String(res.token || ''))
      setPreview(Array.isArray(res.preview) ? res.preview : [])
      if (typeof res.price_formatted === 'string' && res.price_formatted.trim()) {
        setPriceFormatted(res.price_formatted)
      }
    } catch (e: any) {
      console.error('[Express] generate -> error', e)
      alert(apiService.extractErrorMessage(e))
    } finally {
      setLoading(false)
    }
  }

  async function unlock() {
    if (!token) { alert('Token não encontrado. Gere os jogos primeiro.'); return }
    try {
      const res = await apiService.expressPixCreate(token)
      console.log('[Express] unlock -> charge created', res)
      setTxid(res.txid)
      setQrCode(res.qr_code)
      setPixCode(res.copia_cola)
      setPixStatus('pending')
      startPolling(res.txid)
      startCountdown(computeSeconds(res.expires_at))
    } catch (e: any) {
      console.error('[Express] unlock -> error', e)
      alert(apiService.extractErrorMessage(e))
    }
  }

  function startPolling(t: string) {
    if (intervalId) window.clearInterval(intervalId)
    const id = window.setInterval(() => checkStatus(t), 2000)
    setIntervalId(id)
    console.log('[Express] startPolling', { txid: t })
    checkStatus(t)
  }

  async function checkStatus(forceTxid?: string) {
    const currentTxid = forceTxid || txid
    if (pixStatus === 'paid' || pixStatus === 'expired') {
      if (intervalId) { window.clearInterval(intervalId); setIntervalId(null) }
      if (countdownId) { window.clearInterval(countdownId); setCountdownId(null) }
      return
    }
    if (!currentTxid || checking) return
    setChecking(true)
    try {
      const res = await apiService.expressPixStatus(currentTxid)
      console.log('[Express] checkStatus -> response', res)
      setPixStatus(res.status)
      setLastCheckedAt(new Date().toLocaleTimeString())
      if (res.status === 'paid' && Array.isArray(res.full_games)) {
        setFullGames(res.full_games)
        if (intervalId) { window.clearInterval(intervalId); setIntervalId(null) }
        if (countdownId) { window.clearInterval(countdownId); setCountdownId(null) }
        setSecondsLeft(null)
      } else if (res.status === 'expired') {
        if (intervalId) { window.clearInterval(intervalId); setIntervalId(null) }
        if (countdownId) { window.clearInterval(countdownId); setCountdownId(null) }
        setSecondsLeft(null)
      }
    } catch {}
    setChecking(false)
  }

  useEffect(() => {
    if (pixStatus !== 'pending') {
      if (intervalId) { window.clearInterval(intervalId); setIntervalId(null) }
      if (countdownId) { window.clearInterval(countdownId); setCountdownId(null) }
    }
  }, [pixStatus])

  useEffect(() => {
    return () => {
      if (intervalId) window.clearInterval(intervalId)
      if (countdownId) window.clearInterval(countdownId)
    }
  }, [])

  function copyPixCode() {
    if (!pixCode) return
    navigator.clipboard.writeText(pixCode).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    }).catch(() => {})
  }

  async function viewPdf() {
    if (!token) return
    try {
      const url = `/api/express/pdf/${token}?ts=${Date.now()}`
      window.open(url, '_blank', 'noopener,noreferrer')
    } catch (e: any) {
      alert(apiService.extractErrorMessage(e))
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-200 text-slate-900">
      <nav className="border-b border-slate-200 bg-white/80 backdrop-blur-xl sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logo-clover.png" alt="Premiei" className="h-10 w-10" />
            <span className="text-2xl font-bold bg-gradient-to-r from-green-600 to-emerald-500 bg-clip-text text-transparent">Premiei</span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="/" className="px-6 py-2.5 text-sm font-medium text-slate-600 hover:text-slate-900">Home</Link>
          </div>
        </div>
      </nav>

      <section className="relative pt-12 pb-8 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl font-extrabold mb-2">Mega da Virada</h1>
          <div className="text-5xl font-black text-amber-500 mb-2">R$ 1.000.000.000</div>
          <p className="text-slate-600 mb-4">Gere agora 3 jogos com inteligência do Premiei</p>
          <p className="text-slate-500 text-sm mb-2">Sem cadastro • PIX • Liberação automática</p>
        </div>
      </section>

      <section className="px-6">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-6">
          <h2 className="text-xl font-bold text-center mb-4">Configure seus jogos</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            <div>
              <label className="font-semibold mb-2 block">Dezenas</label>
              <div className="flex items-center gap-2 bg-slate-100 rounded-xl p-1">
                <button className="h-11 w-11 rounded-lg bg-slate-200 text-lg font-bold" onClick={()=> setDezenas(clampDezenas(dezenas-1))} disabled={dezenas===6}>−</button>
                <div className="flex-1 text-center text-lg font-bold">{dezenas}</div>
                <button className="h-11 w-11 rounded-lg bg-slate-200 text-lg font-bold" onClick={()=> setDezenas(clampDezenas(dezenas+1))} disabled={dezenas===15}>+</button>
              </div>
            </div>
            <div>
              <label className="font-semibold mb-2 block">Apostas</label>
              <div className="flex items-center gap-2 bg-slate-100 rounded-xl p-1">
                <button className="h-11 w-11 rounded-lg bg-slate-200 text-lg font-bold" onClick={()=> setApostas(clampApostas(apostas-1))} disabled={apostas===3}>−</button>
                <div className="flex-1 text-center text-lg font-bold">{apostas}</div>
                <button className="h-11 w-11 rounded-lg bg-slate-200 text-lg font-bold" onClick={()=> setApostas(clampApostas(apostas+1))} disabled={apostas===20}>+</button>
              </div>
            </div>
          </div>
          <div className="bg-gradient-to-br from-cyan-50 to-blue-50 border-2 border-cyan-400 rounded-xl p-4 text-center mb-2">
            <div className="text-sm text-slate-500">Preço total</div>
            <div className="text-3xl font-extrabold text-cyan-600">{priceFormatted}</div>
          </div>
          <p className="text-center text-slate-500 text-sm">Mais dezenas e mais apostas aumentam sua chance matemática.</p>
          <div className="text-center mt-4">
            <button onClick={generate} disabled={loading} className="relative px-6 py-3 rounded-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-green-600">
              <span className="invisible">{buttonMaxText}</span>
              <span className="absolute inset-0 flex items-center justify-center">
                {loading ? loadingTips[loadingTipIndex] : 'GERAR MEUS NÚMEROS AGORA'}
              </span>
            </button>
          </div>
        </div>
      </section>

      {Array.isArray(preview) && preview.length > 0 && (
        <section className="px-6 py-8">
          <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-6">
            <h3 className="text-xl font-bold text-center mb-4">Seus jogos gerados</h3>
            <p className="text-center text-slate-600 mb-4">Seus jogos completos foram gerados com inteligência estatística.</p>
            <div className="space-y-3">
              {preview.map((game, idx) => (
                <div key={idx} className="bg-amber-50 border border-amber-300 rounded-xl p-3">
                  <div className="flex items-center justify-between mb-2">
                    <div className="font-semibold text-amber-800">Jogo {idx+1}</div>
                    <div className="px-3 py-1 rounded-full bg-amber-500 text-white text-xs font-bold">PARCIAL</div>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {(Array.isArray(game) ? game : []).map((n, i) => (
                      <div key={i} className={`w-10 h-10 rounded-full border-2 flex items-center justify-center font-bold ${n==='XX' ? 'bg-slate-200 border-slate-400 text-slate-600' : 'bg-white border-amber-400 text-amber-800'}`}>{n}</div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <div className="text-center mt-4">
              <button onClick={unlock} className="px-6 py-3 rounded-xl font-bold text-white bg-gradient-to-r from-red-500 to-rose-600">DESBLOQUEAR TODOS OS NÚMEROS ({priceFormatted})</button>
            </div>
          </div>
        </section>
      )}

      {pixStatus !== 'idle' && (
        <section className="px-6 py-8">
          <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-lg p-6 text-center">
            <h3 className="text-xl font-bold mb-4">Pagamento via PIX</h3>
            <div className="mx-auto max-w-xs border-2 border-dashed border-slate-300 rounded-xl p-4 bg-slate-50">
              {qrCode ? (
                <img src={qrCode.startsWith('data:image') ? qrCode : `data:image/png;base64,${qrCode}`} alt="QR Code PIX" className="w-48 h-48 mx-auto" />
              ) : (
                <div className="w-12 h-12 border-4 border-slate-300 border-t-cyan-500 rounded-full animate-spin mx-auto"></div>
              )}
            </div>
          <div className="bg-slate-100 rounded-lg p-3 mt-4 text-left">
            <div className="text-xs text-slate-500 mb-1">Copia e Cola PIX</div>
            <div className="text-[12px] break-all text-slate-700">{pixCode || 'Carregando código...'}</div>
            <button onClick={copyPixCode} className="mt-2 px-3 py-2 rounded-lg text-xs font-semibold bg-emerald-500 text-white hover:bg-emerald-600">
              {copied ? 'COPIADO!' : 'COPIAR CÓDIGO PIX'}
            </button>
          </div>
          <div className={`mt-3 font-semibold ${pixStatus==='paid' ? 'text-emerald-600' : pixStatus==='expired' ? 'text-rose-600' : 'text-slate-600'}`}>
            {pixStatus==='paid' ? 'Pagamento confirmado! ✅' : pixStatus==='expired' ? 'Pagamento expirado' : 'Aguardando pagamento...'}
          </div>
          {pixStatus==='pending' && (
            <div className="mt-2 text-sm text-slate-600">
              Tempo para pagamento: {secondsLeft !== null ? formatSeconds(secondsLeft) : '04:00'}
            </div>
          )}
          
          </div>
        </section>
      )}

      {pixStatus==='paid' && Array.isArray(fullGames) && fullGames.length>0 && (
        <section className="px-6 py-8">
          <div className="max-w-3xl mx-auto bg-gradient-to-br from-emerald-50 to-green-50 rounded-2xl shadow-lg p-6 text-center">
            <div className="w-20 h-20 rounded-full bg-emerald-500 text-white text-3xl font-bold flex items-center justify-center mx-auto mb-4">✓</div>
            <h3 className="text-2xl font-extrabold text-emerald-800 mb-2">Pagamento confirmado!</h3>
            <p className="text-emerald-700 mb-4">Seus números completos estão disponíveis</p>
            <div className="space-y-3 text-left">
              {fullGames.map((game, idx) => (
                <div key={idx} className="bg-amber-50 border border-amber-300 rounded-xl p-3">
                  <div className="flex items-center justify-between mb-2">
                    <div className="font-semibold text-amber-800">Jogo {idx+1}</div>
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {(Array.isArray(game) ? game : []).map((n, i) => (
                      <div key={i} className={`w-10 h-10 rounded-full border-2 flex items-center justify-center font-bold bg-white border-amber-400 text-amber-800`}>{n}</div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
            <button onClick={viewPdf} className="mt-4 px-6 py-3 rounded-xl font-bold text-white bg-gradient-to-r from-blue-500 to-indigo-600">VER PDF</button>
            <button onClick={()=> { setShowWhatsModal(true); if (!whatsPhone) setWhatsPhone('55') }} className="mt-3 ml-2 px-6 py-3 rounded-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-green-600">📲 Enviar minhas apostas no WhatsApp</button>
          </div>
        </section>
      )}

      {showWhatsModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6">
            <h4 className="text-lg font-bold mb-2">Enviar no WhatsApp</h4>
            <p className="text-sm text-slate-600 mb-3">Informe com DDI +55 e DDD</p>
            <input
              value={whatsPhone}
              onChange={(e)=> {
                const digits = e.target.value.replace(/\D+/g, '')
                const norm = digits.startsWith('55') ? digits : ('55' + digits)
                setWhatsPhone(norm)
              }}
              placeholder="Ex: 11999999999"
              className="w-full border border-slate-300 rounded-lg px-3 py-2 text-sm mb-3"
            />
            <div className="flex gap-2">
              <button onClick={()=> setShowWhatsModal(false)} className="px-4 py-2 rounded-lg bg-slate-200 text-slate-800 font-semibold">Cancelar</button>
              <button onClick={async ()=> {
                if (!token) return
                setSendingWhats(true)
                setWhatsFeedback(null)
                try {
                  const digits = whatsPhone.replace(/\D+/g, '')
                  const normalized = digits.startsWith('55') ? digits : ('55' + digits)
                  const res = await apiService.expressWhatsappSend(token, normalized)
                  setWhatsFeedback('✅ Enviado no WhatsApp')
                  setShowWhatsModal(false)
                  setWhatsPhone('')
                } catch (e:any) {
                  setWhatsFeedback('⚠️ Não foi possível enviar, verifique o número e tente novamente')
                } finally {
                  setSendingWhats(false)
                }
              }} className="px-4 py-2 rounded-lg bg-emerald-600 text-white font-semibold">
                {sendingWhats ? 'Enviando...' : 'Enviar'}
              </button>
            </div>
            {whatsFeedback && (
              <div className="mt-3 text-sm">{whatsFeedback}</div>
            )}
          </div>
        </div>
      )}

      <footer className="py-12 px-6 border-t border-slate-200">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-slate-500 text-sm">© {new Date().getFullYear()} Premiei. Todos os direitos reservados.</p>
          <div className="mt-2 text-slate-600 text-xs bg-slate-100 inline-block px-3 py-2 rounded">Premiei não garante premiação. Loterias envolvem sorte. Ferramenta de apoio baseada em estatística.</div>
        </div>
      </footer>
    </div>
  )
}
